import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { environment } from '../../../../environments/environment';
import { CompanyBuilder } from '../../models/builders/company.builder';
import { Company } from '../../models/company';
import { HttpService } from '../base/http.service';

const companyRequest = (company) => {
  return {
    name: company.name,
    address: company.address,
    province: company.province,
    postalCode: company.postalCode,
    companyRegistrationNumber: company.companyRegistrationNumber,
  };
};

@Injectable()
export class CompanyHttpService {
  private apiUrl: string;

  constructor(private httpService: HttpService) {
    this.apiUrl = `${environment.apiUrl}`;
  }

  editCompany(company: Company) {
    const postOptions = companyRequest(company);
    return this.httpService.post(`${this.apiUrl}companies`, postOptions);
  }

  editCompanyAccess(email: string, password: string, passwordRepeat: string) {
    const putBody = { email, password, passwordRepeat };
    return this.httpService.put(`${this.apiUrl}companies/access`, putBody);
  }

  getCompany() {
    return this.httpService.get(`${this.apiUrl}companies`)
      .map((response: Response) => response.json())
      .map(CompanyBuilder.companyFromJson);
  }

  getCompanyAccess() {
    return this.httpService.get(`${this.apiUrl}companies/access`)
      .map((response: Response) => response.json())
      .map(CompanyBuilder.companyAccessFromJson);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/api/company-http.service.ts